"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _box = require("@oneloop/box");
var _label = require("@oneloop/label");
var _text = require("@oneloop/text");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _excluded = ["prefix", "suffix", "contL", "contR", "contT", "contB"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Textarea = exports.Textarea = function Textarea(_ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    contL = _ref.contL,
    contR = _ref.contR,
    contT = _ref.contT,
    contB = _ref.contB,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    display: "inline-block",
    ml: contL,
    mr: contR,
    mt: contT,
    mb: contB
  }, prefix && /*#__PURE__*/_react["default"].createElement(_label.Label, {
    __css: {
      fontWeight: '700',
      fontSize: '12px',
      marginLeft: '5px',
      marginBottom: '5px',
      color: '#384248',
      fontFamily: 'Nunito Sans'
    }
  }, prefix), /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "textarea",
    type: "text",
    tx: "forms",
    variant: "textarea"
  }, props, {
    __css: {
      borderRadius: '8px',
      border: 'solid 1px transparent',
      caretColor: '#757575',
      color: _theme["default"].colors.neutralGray1,
      fontFamily: 'Nunito Sans',
      backgroundColor: _theme["default"].colors.neutralGray8,
      resize: 'none',
      fontSize: '14px',
      height: 170,
      width: 390,
      py: 11,
      px: 5,
      '&::placeholder': {
        fontWeight: '400',
        fontSize: '14px',
        color: _theme["default"].colors.neutralGray2
      },
      '&:disabled': {
        color: '#999999',
        backgroundColor: '#EBEBEB',
        cursor: 'not-allowed'
      },
      '&:focus': {
        outline: 'none',
        border: "1px solid ".concat(_theme["default"].colors.neutralGray3),
        boxShadow: 'none'
      },
      '&:active': {
        outline: 'none'
      },
      '&:hover': {
        '&::placeholder': {
          color: _theme["default"].colors.black
        }
      }
    }
  })), suffix && /*#__PURE__*/_react["default"].createElement(_text.Text, {
    fontWeight: "400",
    color: "#384248",
    fontSize: "12px",
    variant: "large",
    marginLeft: "5px"
  }, suffix));
};
Textarea.propTypes = {
  placeholder: _propTypes["default"].string
};
Textarea.defaultProps = {
  disabled: false
};